module.exports = __webpack_public_path__ + "static/media/line.1756e1e8.svg";